/** @jsx jsx */
import {
  Modal,
  ModalActionButton,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalHeading,
  ModalProps,
  Paragraph,
} from "@eworkit/iris";
import { FC, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

export interface NewTimeReportVersionModalProps extends ModalProps {
  refetchTimeReport: () => Promise<unknown>;
}

export const NewTimeReportVersionModal: FC<NewTimeReportVersionModalProps> = ({ refetchTimeReport, ...modalProps }) => {
  const { t } = useTranslation("session");

  const [isFetching, setIsFetching] = useState(false);

  const handleRefreshButtonClick = useCallback(async () => {
    setIsFetching(true);

    await refetchTimeReport();

    setIsFetching(false);
    modalProps.dialogState.hide();
  }, [refetchTimeReport, modalProps]);

  return (
    <Modal aria-label={t("TIME_REPORTS.EDIT.NEW_VERSION_AVAILABLE")} {...modalProps}>
      <ModalContainer>
        <ModalHeader
          onCloseClick={modalProps.dialogState.hide}
          closeButtonAriaLabel={t("COMPONENTS.MODAL.CLOSE")}
          headerPlaceholder={<ModalHeading>{t("TIME_REPORTS.EDIT.NEW_VERSION_AVAILABLE")}</ModalHeading>}
        />

        <ModalContent>
          <Paragraph>{t("TIME_REPORTS.EDIT.NEW_VERSION_AVAILABLE_DESCRIPTION")}</Paragraph>
        </ModalContent>

        <ModalFooter>
          <ModalActionButton type="button" variant="ghost" onClick={modalProps.dialogState.hide}>
            {t("TIME_REPORTS.EDIT.NEW_VERSION_CANCEL")}
          </ModalActionButton>
          <ModalActionButton variant="primary" onClick={handleRefreshButtonClick} disabled={isFetching}>
            {t("TIME_REPORTS.EDIT.NEW_VERSION_REFRESH_PAGE")}
          </ModalActionButton>
        </ModalFooter>
      </ModalContainer>
    </Modal>
  );
};
